import {usePlaneduHttpService} from "../service/planedu.http.service";
import {FinancialEntryItemEntity} from "../entity/financial-entry-item.entity";

export function useFinancialEntryItemRepository() {
    const httpService = usePlaneduHttpService<FinancialEntryItemEntity>('financial-entry-item');
    return {
        ...httpService,
    }
}